import { createAsyncThunk } from '@reduxjs/toolkit';
import { mfaLogin } from 'services/authorization/authorization.service';
import { ILoginRequestPayload, ILoginResponse } from 'services/authorization/types';

export const ThunkMfaLogin = createAsyncThunk<ILoginResponse, ILoginRequestPayload>(
  'authorization/mfaLogin',
  payload => mfaLogin(payload).then(res => res.data),
);
